// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__fZfIO","ping":"styles_ping__eUA4J","skeleton-animation":"styles_skeleton-animation__eNrev","pulse":"styles_pulse__dTJQC"};